export default function FieldType1({ type, info, onClick }) {
    return (
        <div id={`${type}-${info.id}`} className={type}>
            {info.text ? (
                <div onClick={onClick}>{info.text}</div>
            ) : (
                <img onClick={onClick} src={info.image} alt="image" />
            )}
        </div>
    );
}
